function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg viewBox="0 0 20 29" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><path stroke="#ff9292" strokeWidth="3" d="M0 0h20v29H0z" /><path fill="#f9adad" d="M.857.853h18.286v28.15H.857z" /><g fill="#ffbfbf"><g stroke="#ff9292"><path d="M2.857 3.98h5.714v9.382H2.857zM11.429 3.98h5.714v9.382h-5.714zM2.857 17.06h5.714v9.382H2.857zM11.429 17.06h5.714v9.382h-5.714z" /></g><ellipse cx="17.6" cy="15.306" rx=".8" ry=".806" /></g></g></svg>;
});